<template>
  <v-container fluid class="pl-15 pr-10">
    <v-row>
      <v-col class="pt-10 pl-4 d-flex justify-space-between">
         <v-menu v-model="filter" rounded offset-x :close-on-content-click="false">
         <template v-slot:activator="{ attrs, on }">
          <v-btn depressed v-bind="attrs" v-on="on" color="#d8e7f5">
            <v-icon small color="titleText">mdi-filter-variant</v-icon>
            <span class="titleText--text font-weight-bold ml-3"
              >Choose scope of project</span
            >
          </v-btn>
        </template>
          <ProjectSetupCtrl ref="projectsetupctrl"></ProjectSetupCtrl>
        </v-menu>
      </v-col>
    </v-row>
    <v-progress-linear
      v-if="!ishavemmmdata"
      indeterminate
      color="cyan"
    ></v-progress-linear>
    <v-row class="pt-0">
      <v-col cols="12">
        <v-row>
          <div v-if="!ishavemmmdata">Loading some data</div>
          <v-col cols="12">
            <div class="d-flex">
              <h2 class="titleText--text">Data for modelling</h2>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon  v-bind="attrs" size="medium"
                  v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
                </template>
                <span> Raw data which should include atleast time, sales value, sales <br>
                volume & activity variables for chosen country & brand
                combination. <br> This is main data to build marketing-mix model.</span>
              </v-tooltip>
            </div>
            <v-card class="mt-3 custom-shadow" flat>
                <div v-if="ishavemmmdata">
                  <v-simple-table fixed-header height="450px">
                    <thead>
                      <tr>
                        <th
                          v-for="(element, key) in this.mmmdata[0]"
                          :key="element.variable"
                          class="text-center titleText--text text-capitalize"
                          style="background: #f1f1f1"
                        >
                          <span v-if="key === 'Sales_Value'">{{key}} ({{currency}})</span>
                          <span v-else>{{ key }}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in mmmdata" :key="item">
                        <td v-for="(element, index) in item" :key="index" class="text-right titleText--text">
                          <span v-if="fullNameIsExist(index)">
                            {{ index === 'date' ? formattedDate(element) : element }}
                          </span>
                          <span v-else-if="index === 'Sales_Value'">
                            {{ currencyNumberFormat(element) }}
                          </span>
                          <span v-else>{{ numberFormat(element) }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </div>
                <div v-else>
                  {{ this.strnodatafount }}
                </div>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="6">
                <div class="d-flex">
                  <h2 class="titleText--text">HCP coverage by each channel</h2>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon  v-bind="attrs" size="medium"
                      v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
                    </template>
                    <span> Raw data which must include cost per point (CPP) of each
                      activity to compute ROI.</span>
                  </v-tooltip>
                </div>
                <v-card class="custom-shadow mt-3" flat>
                  <v-card-text>
                    <ChartOne ref="chartHCPCoverage"></ChartOne>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="6">
                <div class="d-flex">
                  <h2 class="titleText--text">Cost per point & effective frequency of channels</h2>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                      size="medium"
                      v-bind="attrs"
                      v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
                    </template>
                    <span> Raw data which must include productive universe, client <br>
                    coverage & effective frequency for last 12 months of each <br>
                    activity to build saturation curves.</span>
                  </v-tooltip>
                </div>
                <v-card class="custom-shadow mt-3" flat>
                  <v-card-text>
                    <chartmultiaxis ref="chartmix"></chartmultiaxis>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-navigation-drawer
          v-model="draweraddnew"
          absolute
          temporary
          right
          width="400px"
          height="full"
        >
          <app-widget
            title="Add New Project"
            titleicon="mdi-data-matrix"
            imgname="bar-chart--v2.png"
            headingicon="true"
            headingendicon="true"
          >
            <div slot="widget-header-action">
              <v-btn icon @click="closeForm()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div slot="widget-content">
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                @submit.prevent="submit"
              >
                <v-text-field
                  v-model="projectName"
                  :counter="50"
                  :rules="nameRules"
                  label="*Project Name"
                  required
                ></v-text-field>
                <small class="d-flex align-start"
                  >*indicates required field</small
                >
                <v-spacer></v-spacer>

                <v-btn depressed color="primary" @click="createNewProject()">
                  <v-icon right dark> mdi-cloud-upload </v-icon>
                  <span class="button-caption">Save</span>
                </v-btn>
              </v-form>
            </div>
          </app-widget>
        </v-navigation-drawer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import jsoncountry from "../mockdata/countrydataarray.json";
import AppWidget from "../../../components/AppWidget.vue";
import ProjectSetupCtrl from "./projectsetupctrl.vue";
import ChartOne from "./ChartHCPCoverage.vue";
import chartmultiaxis from "./multaxixchart.vue";
import apifactory from "../api";
import storagefactory from "../../../global/GlobalStrorage";
import globalclass from "../../../global/globalvar";
import moment from 'moment'

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
import GlobalStrorage from "../../../global/GlobalStrorage";

Vue.use(VueAxios, axios);
export default {
  name: "summary",
  components: {
    AppWidget,
    ProjectSetupCtrl,
    ChartOne,
    //ChartCPPPEFC,
    chartmultiaxis,

  //  CtrlNavButton,
  },
  data: () => ({
    prevstepQueryStringParm: null,
    curentstep: globalclass.PARAM_Step_MDP_SP_PS,
    projectName: null,
    projectid: null,
    lstofaverageparm: null,
    loginuserid: 0,
    nameRules: [
      (v) => !!v || "Project Name is required",
      (v) => (v && v.length <= 50) || "Name must be less than 50 characters",
    ],
    tempinfo: null,
    tempinfonew: [],
    strnodatafount: "Sorry No data Found.",
    cppdata: null,
    ishavecppdata: false,

    ishaverscurvedata: true,

    ishavemmmdata: true,
    mmmdata: [],
    mmmdatanew: [],

    rscurve: null,
    mmmdataheader: [],
    loadingdata: false,

    countryitmes: [],
    lstofCountry: jsoncountry.vardata,
    selectedCountry: null,
    branditmes: ["xyz"],
    selectedBrand: null,
    selectedlevel: null,
    isButtonDisabled: true,
    isNexbuttonDisabled: true,
    currency: localStorage.getItem('currency'),
    cppheaders: [
      {
        text: "activity (100g serving)",
        align: "left",
        sortable: false,
        value: "activity",
        class: "success--text title",
      },
      {
        text: "cpp",
        value: "cpp",
      },
    ],
    drawer: null,
    draweraddnew: null,
    items: [
      {
        title: "Home",
        icon: "mdi-view-dashboard",
      },
      {
        title: "About",
        icon: "mdi-forum",
      },
    ],
    issubregion: 1,
    //colum description
    columndesc: null,
    columndescvalue: "",
  }),
  computed: {
    fullName() {
      return (theParam) => {
        //let tempparam=theParam + 'test';
        let desc = [];
        desc = this.columndesc.filter((a) => a.column == theParam);
        //return `The following is the Parameter from *Multi* Line Arrow Function >>> ${desc[0].description}`
        return desc[0].description;
      };
    },
  },
  unmounted() {},
  mounted() {
    
    if (storagefactory.getProjectID() <= 0) {
      this.$router.push("/dashboard");
    }
    this.loginuserid = storagefactory.getloginuserid();
    this.getParametrOfPrvStep();
    this.getmmmdata();
  },
  watch: {
    selectedCountry: function () {
      this.isButtonDisabled = false;
    },
    getcolumndesciption: function (fieldname) {
      this.columndescvalue = fieldname;
    },
    cppdata: function (varvalue) {
      this.$refs.chartHCPCoverage.inputdata = varvalue;
      this.$refs.chartHCPCoverage.loadchart(varvalue);

      this.$refs.chartmix.inputdata = varvalue;
      this.$refs.chartmix.loadchart(varvalue);
    },
  },

  methods: {
    formattedDate (date) {
      return moment(date).format("DD.MM.YYYY")
    },
    currencyNumberFormat (number) {
      const formatter = new Intl.NumberFormat('en-CA', {
        style: 'currency',
        maximumFractionDigits: 0,
        currency: this.currency || 'usd'
      })

      return formatter.format(number);
    },
    numberFormat (number) {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 0,
      })

      return formatter.format(number)
    },
    fullNameIsExist(item) {
      let outresult = false;
      if (item == "date") {
        outresult = true;
      }
      if (item == "region") {
        outresult = true;
      }
      return outresult;
    },
    showtitle(varcolumnname) {
      return varcolumnname;
    },
    onnextclick() {
      window.location.reload();
      this.saveAndSetStepParms();
    },
    openProjectSetupCtrl() {
      this.$refs.projectsetupctrl.openpopup();
    },
    binddefalutvalues() {
      window.scrollTo(0, 0);
      this.nextclick();
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    closeForm() {
      this.reset();
      this.draweraddnew = false;
    },
    reserve() {
      this.loading = true;

      setTimeout(() => (this.loading = false), 2000);
    },
    nextclick() {
      this.openWindowForNewProject();
    },
    getdataonclick() {
      this.loadingdata = true;
      this.saveAndSetStepParmsForInitate();
    },
    getcountry() {
      apifactory
        .api_get_available_data()
        .then((response) => (this.countryitmes = response.data));
    },

    getcppdata() {
      apifactory
        .getcppdata_rcpp()
        .then((res) => {
          if (res.status === false) {
            this.cppdata = null;
            this.ishavecppdata = false;
          } else {
            this.cppdata = res.data;

            if (typeof this.cppdata.length == "undefined") {
              this.ishavecppdata = false;
              this.isNexbuttonDisabled = true;
            } else {
              if (this.cppdata.length > 0) {
                this.ishavecppdata = true;
                this.isNexbuttonDisabled = false;
              } else {
                this.ishavecppdata = false;
                this.isNexbuttonDisabled = true;
              }
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getmmmdata() {
      apifactory
        .api_get_project_data()
        .then((res) => {
          this.mmmdata = res.data.data;
          this.columndesc = res.data.column_description;
          this.ishavemmmdata = true;
          this.ishavecppdata = true;
          this.cppdata = res.data.kpi;
          this.$refs.chartHCPCoverage.inputdata = this.cppdata;
          this.$refs.chartHCPCoverage.loadchart(this.cppdata);

          this.$refs.chartmix.inputdata = this.cppdata;
          this.$refs.chartmix.loadchart(this.cppdata);

          if (this.cppdata == null) {
            this.$refs.projectsetupctrl.openpopup();
          }
        })
        .catch(function (error) {
            console.warn(error);
          this.$refs.projectsetupctrl.openpopup();
        });
    },
    getcurvedata() {
      apifactory
        .get_rscurve()
        .then((res) => {
          if (res.status === false) {
            this.rscurve = null;
          } else {
            this.rscurve = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getdatafromserver() {
      this.loadingdata = true;

      for (var i = 0; i < this.mmmdataheader.length; i++) {
        var obj = this.mmmdataheader[i];
        this.tempinfonew.push(obj);
      }
    },
    openWindowForNewProject() {
      if (storagefactory.getProjectName() == null) {
        this.draweraddnew = true;
      } else {
        this.saveAndSetStepParms();
        GlobalStrorage.setcurrentstep("2");
      }
    },
    createNewProject() {
      if (this.$refs.form.validate()) {
        this.saveNewProject();
      }
    },
    saveNewProject() {
      apifactory
        .createNewProject(this.projectName, this.loginuserid)
        .then((res) => {
          if (res.data.id == "undefined") {
            this.$swal("Sorry");
          } else {
            storagefactory.setProjectID(res.data.id);
            storagefactory.setProjectName(this.projectName);

            this.saveAndSetStepParms();
          }
        });
    },
    CheckNextStepParms() {
      apifactory
        .gettheParameterByProjectStepSummary()
        .then((res) => {
          if (res.status != 200) {
            alert("error:-" + JSON.stringify(res.data));
          } else {
            if (res.data.status == -1) {
              this.saveAndSetStepParmsNew();
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    saveAndSetStepParms() {
      this.CheckNextStepParms();
    },
    saveAndSetStepParmsNew() {
      if (this.lstofaverageparm == null) {
        this.lstofaverageparm = "''";
      }
      let url_querystring = "average=" + this.lstofaverageparm;

      apifactory.addParameterBySteps("2", url_querystring)
    },
    getParametrOfPrvStep() {
      this.prevstepQueryStringParm = "";

      apifactory
        .gettheParameterByProjectStep()
        .then((res) => {
          if (res.status != 200) {
            this.prevstepQueryStringParm = "";
          } else {
            this.prevstepQueryStringParm = res.data;
            this.selectedCountry = res.data["country"];
            this.selectedBrand = res.data["brand"];
            this.selectedlevel = res.data["level"];
            localStorage.setItem('currency', res.data.currency)
            let strurl = "";
            for (var k in this.prevstepQueryStringParm) {
              if (k != "step") {
                strurl =
                  strurl + k + "=" + this.prevstepQueryStringParm[k] + "&";
              }
            }
            strurl = strurl.slice(0, -1);
            this.prevstepQueryStringParmUrl = strurl;

            this.projectid = storagefactory.getProjectID();
            this.projectName = storagefactory.getProjectName();
            if (res.data.status === -1) {
              this.selectedCountry = null;
              this.selectedBrand = null;
              this.selectedlevel = null;
            }

            if (this.selectedCountry != null) {
              this.getdataonclick();
            }
            if (this.selectedCountry === null) {
              this.drawer = true;
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
      if (this.prevstepQueryStringParm.length === 0) {
        this.drawer = true;
      }
    },

    getprojectdata() {
      apifactory
        .api_get_project_data()
        .then((res) => {
          if (res.status === false) {
            this.rscurve = null;
          } else {
            this.rscurve = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
};
</script>

<style>
.header-icon-space {
  padding-right: 10px !important;
}

.icon-space {
  padding-right: 10px !important;
}
.filter-icon {
  padding-left: 10px !important;
  padding-right: 2px !important;
  margin-bottom: 10px !important;
  height: 20px !important;
  width: 20px !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr:not(:last-child)>td:not(.v-data-table__mobile-row) {
  border-bottom: 1px solid #f1f1f1
}

.v-btn {
  text-transform: none !important;
}
</style>
